import { ADD_EXPRESS_CHARGES } from "../../actions/ecommerce/constants";

const initialState = {
  expressCharges: [],
};

const expressChargesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EXPRESS_CHARGES: {
      return {
        ...state,
        expressCharges: [...action.payload],
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default expressChargesReducer;
